import GSAP from 'gsap'
import Animation from 'classes/Animation'

export default class Images extends Animation {
  constructor ({ element, elements }) {
    super({
      element,
      elements
    })

    this.image = this.element.querySelector('img')
    this.duration = this.element.getAttribute('data-duration')

    this.parallax = {
      current: 0,
      target: 0,
      smoothness: 8,
      strength: this.element.getAttribute('data-parallax-strength')
    }

    this.parallax.smoothness = this.parallax.smoothness / 100
  }

  animateIn () {
    this.timelineIn = GSAP.timeline({ paused: true })

    this.timelineIn.fromTo(this.image, {
      scale: '1.2',
      y: '0',
      ease: 'power4'
    }, {
      scale: '1',
      y: '0',
      ease: 'power4'
    })

    if (this.parallax.strength) {
      this.timelineIn.fromTo(this.element, {
        y: '-20%',
        ease: 'power4'
      }, {
        y: '0%',
        ease: 'power4'
      })
    }

    this.update()
  }

  update () {
    const elWindow = window.scrollY + window.innerHeight
    this.elSize = null
    // this.elTop = this.element.offsetTop
    this.elTop = this.element.getBoundingClientRect().top
    this.elHeight = this.element.getBoundingClientRect().height

    if (this.parallax.strength) {
      this.elTop = (this.elHeight * this.parallax.strength) + this.elTop
    } else {
      this.elTop = this.elHeight + this.elTop
    }
    const finalValue = (this.elTop / elWindow)

    this.timelineIn.progress(finalValue)

    this.frame = window.requestAnimationFrame(this.update.bind(this))
  }

  animateOut () {
    window.cancelAnimationFrame(this.frame)
  }
}
